import type { BaseSelectProps } from "@mui/material";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import type { FC } from "react";
import type { CustomRepeatType } from "../hooks/use-number-of-repeats";

type CustomRepeatPeriodProps = Omit<BaseSelectProps, "onChange" | "value"> & {
  value: CustomRepeatType["period"];
  onChange: (value: CustomRepeatType["period"]) => void;
  helperText?: string;
};

export const CustomRepeatPeriod: FC<CustomRepeatPeriodProps> = ({
  value,
  onChange,
  label,
  helperText,
  ...props
}) => {
  return (
    <FormControl sx={{ width: 120 }}>
      <InputLabel id="period-label">{label}</InputLabel>
      <Select
        labelId="period-label"
        label={label}
        value={value}
        onChange={(e) => {
          const val = e.target.value as CustomRepeatType["period"];
          onChange(val);
        }}
        {...props}
      >
        <MenuItem value="day" data-analytics-id="create-event-form-custom-repeat-period-day">
          Days
        </MenuItem>
        <MenuItem value="week" data-analytics-id="create-event-form-custom-repeat-period-week">
          Weeks
        </MenuItem>
        <MenuItem value="month" data-analytics-id="create-event-form-custom-repeat-period-month">
          Months
        </MenuItem>
        <MenuItem value="year" data-analytics-id="create-event-form-custom-repeat-period-year">
          Years
        </MenuItem>
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
